import React from 'react';
import { Button } from './ui/button';
import { ChevronDown } from 'lucide-react';
import { companyInfo } from '../data/mock';
import ElectricPulse from './ElectricPulse';

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-[85vh] flex items-center justify-center overflow-hidden" style={{ backgroundColor: '#1a1411' }}>
      {/* Electric Pulse Animation */}
      <ElectricPulse />
      
      {/* Ambient Background Glow */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] sm:w-[600px] sm:h-[600px] rounded-full blur-[150px] animate-pulse-slow" style={{ backgroundColor: 'rgba(212, 193, 156, 0.1)' }} />
        <div className="absolute bottom-1/4 right-1/4 w-[400px] h-[400px] sm:w-[500px] sm:h-[500px] rounded-full blur-[120px] animate-pulse-slow" style={{ backgroundColor: 'rgba(156, 124, 94, 0.08)', animationDelay: '2s' }} />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 text-center">
        {/* Actual Logo */}
        <div className="flex justify-center mb-8 sm:mb-10">
          <div className="relative group">
            {/* Glow effect behind logo */}
            <div className="absolute inset-0 rounded-2xl blur-3xl opacity-30 group-hover:opacity-50 transition-opacity duration-500" style={{ backgroundColor: '#d4c19c', transform: 'scale(1.1)' }} />
            <img 
              src="https://customer-assets.emergentagent.com/job_guelph-electric/artifacts/8iae4xfm_IMG_1075.jpeg"
              alt="Janes Electrical Services"
              className="relative w-64 sm:w-80 md:w-96 h-auto transform group-hover:scale-105 transition-transform duration-500 rounded-2xl"
              style={{ 
                mixBlendMode: 'lighten',
                filter: 'brightness(1.05)'
              }}
            />
          </div>
        </div>

        {/* Tagline */}
        <p className="text-lg sm:text-xl md:text-2xl mb-6 sm:mb-8 max-w-3xl mx-auto leading-relaxed" style={{ color: '#c4b8a8', fontFamily: "'Rajdhani', sans-serif", fontWeight: 500 }}>
          {companyInfo.tagline}
        </p>

        {/* Location Badge with pulse */}
        <div className="inline-flex items-center gap-2 sm:gap-3 rounded-full px-4 sm:px-8 py-2 sm:py-3 mb-8 sm:mb-12 border location-badge" style={{ backgroundColor: 'rgba(42, 31, 26, 0.8)', borderColor: '#9c7c5e' }}>
          <div className="w-2 h-2 rounded-full bg-pulse" style={{ backgroundColor: '#d4c19c' }} />
          <span className="font-semibold tracking-wide text-sm sm:text-base" style={{ color: '#d4c19c', fontFamily: "'Rajdhani', sans-serif" }}>Serving Guelph, Ontario & Surrounding Areas</span>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 px-4">
          <Button 
            onClick={scrollToContact}
            size="lg"
            className="w-full sm:w-auto font-bold px-8 sm:px-12 py-6 sm:py-7 text-base sm:text-lg rounded-xl shadow-2xl transform hover:scale-105 hover:-translate-y-1 transition-all duration-300 cta-electric"
            style={{ 
              backgroundColor: '#d4c19c', 
              color: '#1a1411',
              boxShadow: '0 20px 40px rgba(212, 193, 156, 0.3)',
              fontFamily: "'Rajdhani', sans-serif",
              letterSpacing: '0.05em'
            }}
          >
            CONTACT US TODAY
          </Button>
          <Button 
            onClick={scrollToServices}
            variant="outline"
            size="lg"
            className="w-full sm:w-auto font-semibold px-8 sm:px-12 py-6 sm:py-7 text-base sm:text-lg rounded-xl hover:-translate-y-1 transition-all duration-300"
            style={{ 
              borderColor: '#9c7c5e', 
              color: '#d4c19c',
              backgroundColor: 'transparent',
              fontFamily: "'Rajdhani', sans-serif",
              letterSpacing: '0.05em'
            }}
          >
            OUR SERVICES
          </Button>
        </div>

        {/* Scroll Indicator */}
        <div className="mt-8 sm:mt-12">
          <div className="animate-bounce p-2 rounded-full inline-block" style={{ backgroundColor: 'rgba(212, 193, 156, 0.1)' }}>
            <ChevronDown className="w-6 h-6 sm:w-8 sm:h-8" style={{ color: '#9c7c5e' }} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
